import { styled } from '@mui/material/styles'
import {
  Box,
  Menu,
  MenuItem,
  Typography,
  TextField,
  Tabs,
  Tab,
} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'

export const StyledMenu = styled(Menu)(({ theme }) => ({
  '& .MuiPaper-root': {
    minWidth: 320,
    maxWidth: 400,
    maxHeight: 450,
    borderRadius: 12,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: 'rgba(255, 255, 255, 0.98)',
    backdropFilter: 'blur(20px)',
    boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
    marginTop: theme.spacing(1),
    '& .MuiList-root': {
      padding: 0,
    },
  },
}))

export const MenuTitle = styled(Typography)(({ theme }) => ({
  padding: '8px 16px',
  fontSize: 14,
  fontWeight: 600,
  color: theme.palette.text.secondary,
  borderBottom: `1px solid ${theme.palette.divider}`,
}))

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  minHeight: 36,
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.primary.main,
  },
  '& .MuiTabs-flexContainer': {
    height: 36,
  },
}))

export const StyledTab = styled(Tab)(({ theme }) => ({
  minHeight: 36,
  fontSize: 12,
  fontWeight: 500,
  textTransform: 'none',
  padding: '6px 16px',
  color: theme.palette.text.secondary,
  '&.Mui-selected': {
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
}))

export const TabContent = styled(Box)(({ theme }) => ({
  maxHeight: 320,
  overflowY: 'auto',
  padding: '8px 0',
}))

export const SearchField = styled(TextField)(({ theme }) => ({
  margin: '12px 8px 8px 8px',
  width: 'calc(100% - 16px)',
  '& .MuiOutlinedInput-root': {
    borderRadius: 8,
    backgroundColor: 'rgba(0, 0, 0, 0.02)',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    '&.Mui-focused': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'transparent',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
  },
  '& .MuiInputBase-input': {
    padding: '10px 12px',
    fontSize: 14,
  },
}))

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  padding: '12px 16px',
  margin: '0 8px',
  borderRadius: 8,
  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.03)',
    transform: 'translateY(-0.5px)',
  },
  '&:active': {
    backgroundColor: 'rgba(0, 0, 0, 0.06)',
    transform: 'translateY(0)',
  },
}))

export const PatientInfo = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  width: '100%',
}))

export const PatientName = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 1,
}))

export const PatientNameText = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 500,
  color: theme.palette.text.secondary,
}))

export const PatientMRN = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.text.secondary,
  opacity: 0.7,
}))

export const DoctorInfo = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 1,
}))

export const DoctorName = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: 14,
  color: theme.palette.text.primary,
  letterSpacing: '-0.01em',
}))

export const AppointmentTime = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.text.secondary,
  opacity: 0.7,
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
}))

export const RoomNumber = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.primary.main,
  opacity: 0.9,
  fontWeight: 500,
}))

export const ProcedureName = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.text.secondary,
  opacity: 0.8,
  fontStyle: 'italic',
}))

export const StyledSearchIcon = styled(SearchIcon)(() => ({
  fontSize: 18,
  color: 'text.secondary',
  opacity: 0.7,
}))

export const EmptyStateContainer = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(3),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  textAlign: 'center',
}))

export const EmptyStateText = styled(Typography)(() => ({
  opacity: 0.7,
}))
